var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheelTriadic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.81 207.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #9500ff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        fill: #ff00b5;\n      }\n\n      .cls-5 {\n        fill: #ff9f19;\n      }\n\n      .cls-6 {\n        fill: #00ff40;\n      }\n\n      .cls-7 {\n        fill: #ff0;\n      }\n\n      .cls-8 {\n        fill: #ff4a00;\n      }\n\n      .cls-9 {\n        fill: red;\n      }\n\n      .cls-10 {\n        fill: #60ff00;\n      }\n\n      .cls-11 {\n        fill: aqua;\n      }\n\n      .cls-12 {\n        fill: #0040ff;\n      }\n\n      .cls-13 {\n        fill: #ffca00;\n      }\n\n      .cls-14 {\n        fill: #4019ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Art"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M103.9,103.91L3.55,130.8c4.73,17.59,14.02,33.69,26.88,46.58l73.47-73.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3.56,77.02c-4.9,18.28-4.59,36.73,0,53.78l100.35-26.89L3.56,77.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.9,103.91h0L30.44,30.45c-12.5,12.47-21.98,28.29-26.88,46.57l100.34,26.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.01,3.55c-17.59,4.73-33.68,14.03-46.57,26.9l73.46,73.46L77.01,3.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.9,103.91L177.37,30.44c-12.47-12.5-28.3-21.98-46.58-26.88l-26.89,100.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.9,103.91L130.79,3.56c-18.28-4.9-36.73-4.6-53.78-.01l26.89,100.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M30.44,177.38c12.47,12.5,28.3,21.98,46.58,26.88l26.89-100.34L30.44,177.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.02,204.25c18.28,4.9,36.73,4.6,53.78.01l-26.89-100.36-26.89,100.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M103.9,103.91h0l100.34,26.89c4.9-18.28,4.59-36.73,0-53.78l-100.35,26.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.26,77.02c-4.73-17.59-14.02-33.69-26.88-46.58l-73.47,73.47,100.35-26.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.9,103.91l26.89,100.36c17.59-4.73,33.68-14.03,46.57-26.9l-73.46-73.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.9,103.91l73.46,73.46c12.5-12.47,21.98-28.29,26.88-46.57l-100.34-26.89Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "104.05 51.61 58.77 130.06 149.34 130.06 104.05 51.61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.05,
    cy: 51.61,
    r: 6.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.77,
    cy: 130.06,
    r: 6.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.04,
    cy: 130.06,
    r: 6.17
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 103.9,
    cy: 103.91,
    r: 71.66
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelTriadic);
export default __webpack_public_path__ + "static/media/wheel-triadic.7293ec5e65b0e289ad28ca4f664e4667.svg";
export { ForwardRef as ReactComponent };